import { isLocal, isProduction } from "@utils/utils";
import { createContext, useContext, useState } from "react";
import { Shield } from "shield-js-npm";
import { captureException } from "@sentry/nextjs";

interface FingerprintData {
  requestId: string;
  visitorId: string;
}

interface FingerprintContextState {
  fingerprint: FingerprintData | null;
  getFingerprint: () => Promise<FingerprintData | null>;
}

const FingerprintContext = createContext<FingerprintContextState>({} as FingerprintContextState);

export const useFingerprintContext = () => {
  const { fingerprint, getFingerprint } = useContext(FingerprintContext);
  return { fingerprint, getFingerprint };
};

interface FingerprintProviderProps {
  children: React.ReactNode;
}

export const FingerprintProvider = ({ children }: FingerprintProviderProps) => {
  const [fingerprint, setFingerprint] = useState<FingerprintData | null>(null);

  const getFingerprint = async () => {
    const siteId = String(process.env.NEXT_PUBLIC_SHIELD_SITE_ID);

    if (isProduction() && siteId) {
      try {
        const shield = new Shield();
        await shield.init({ siteId });
        const data = (await shield.getDeviceIntelligence()) as any;

        const fingerprint = {
          requestId: data.result.session_id,
          visitorId: data.result.device_intelligence.shield_id,
        };

        setFingerprint(fingerprint);

        return fingerprint;
      } catch (e) {
        captureException(e);
      }
    }

    return null;
  };

  return <FingerprintContext.Provider value={{ fingerprint, getFingerprint }}>{children}</FingerprintContext.Provider>;
};
